import React from 'react';
import TransSearchContext from 'src/contexts/TransSearchContext';

const useTranSearch = () => React.useContext(TransSearchContext);
export default useTranSearch;
